"use strict";

dfc.safe(async () => {
  const log = dfc.log.bind(dfc, 'ga4');
  log('running');
  if (/demandware\.net$/i.test(location.hostname)) return log('disabled');

  // cspell: disable
  const G_CODE = (hn => {
    if (/timex\.ca/i.test(hn)) return 'G-2QDEYZNVJD';
    if (/timex\.(eu|it|de|es|fr)/i.test(hn)) return 'G-3MMDXB6ZS1';
    if (/timex\.co\.uk/i.test(hn)) return 'G-SEFJSKJWY5';
    if (/timex\.com/i.test(hn)) return 'G-J0GB29QS3H';
    if (/gcwatches\.com/i.test(hn)) return 'G-2R28LT9XP0';
    if (/guesswatches\.com/i.test(hn)) return 'G-2R28LT9XP0';
  })(location.hostname);
  // cspell: enable

  if (!G_CODE) return log(`No G_CODE for ${location.hostname}`);
  if (dfc.env !== 'dev') dfc.loadScript(`https://www.googletagmanager.com/gtag/js?id=${G_CODE}`);
  window.dataLayer = window.dataLayer || [];
  /*global dataLayer*/
  function gtag() {
    if (dfc.env !== 'dev') dataLayer.push(arguments);
    log('gtag', ...arguments);
  }
  dfc.track = event_name => {
    // eslint-disable-next-line no-console
    if (/^[a-z0-9_]+$/.test(event_name)) return console.error('event_name required to match ^[a-z0-9_]+$');
    gtag('event', event_name);
  };
  await dfc.waitFor(() => window.utag_data);
  const _get = k => {
    return window.utag_data[k];
  };
  const _getArray = k => _get(k) || [];
  const page_name = _get('page_name');
  const page_type = _get('page_type');
  const page_context_type = _get('page_context_type');
  const page_context_title = _get('page_context_title');
  const user_anonymous = _get('user_anonymous');
  const user_authenticated = _get('user_authenticated');
  const user_registered = _get('user_registered');
  const customer_id = _get('customer_id');
  const locale = _get('locale');
  const flow_experience = _get('flow_experience');
  const currency = (() => {
    try {
      return JSON.parse(localStorage.getItem('_f60_session')).experience.currency;
    } catch (e) {
      // continue
    }

    // try from dl for order if exist
    const orderCurrency = _get('order_currency');
    if (orderCurrency) return orderCurrency;

    // <script id='js-flow-session' data-currency='ARS'></script>
    const flowSession = document.getElementById('js-flow-session');
    if (flowSession && flowSession.dataset && flowSession.dataset.currency) {
      return flowSession.dataset.currency;
    }
    const currencyCode = window.googlepayvariables && window.googlepayvariables.currencyCode;
    if (currencyCode) {
      return currencyCode;
    }
    const hn = location.hostname;
    if (/^(www\.)?timex\.ca$/i.test(hn)) return 'CAD';
    if (/^(www\.)?timex\.(eu|it|de|es|fr)$/i.test(hn)) return 'EUR';
    if (/^(www\.)?timex\.co\.uk$/i.test(hn)) return 'GBP';
    if (/^(www\.)?timex\.com$/i.test(hn)) return 'USD';
    if (/^(www\.)?gcwatches\.com$/i.test(hn)) return 'USD';

    // default
    return 'USD';
  })();

  // trim down to avoid undefined issues

  gtag('js', new Date());
  gtag('config', G_CODE, {
    page_name,
    page_type,
    page_context_type,
    page_context_title,
    user_anonymous,
    user_authenticated,
    user_registered,
    user_id: customer_id,
    locale,
    flow_experience
  });
  const $ = await dfc.jQuery;
  const _itemFromData = data => {
    // <param
    // data-prd-id="TW2V51000YB"
    // data-prd-sku="TW2V51000"
    // data-prd-name="Timex Atlantis x Stranger Things 40mm Resin Strap Watch"
    // data-prd-brand="Timex"
    // data-prd-cat="timex-x-stranger-things-shop-all"
    // data-prd-list="best-sellers"
    // data-prd-price="89.0"
    // data-prd-pos="1.0"></param>
    return {
      item_id: data.prdSku,
      item_name: data.prdName,
      currency,
      index: parseInt(data.prdPos, 10),
      item_brand: data.prdBrand,
      item_category: data.prdCat,
      item_list_id: data.prdList,
      item_variant: data.prdId,
      price: parseFloat(data.prdPrice),
      quantity: 1
    };
  };
  const _setStock = item => {
    const in_stock = function () {
      try {
        if (document.querySelector('.in-stock-msg')) return 'in_stock';
        if (document.querySelector('#email-when-in-stock')) return 'email_when_in_stock';
        if (document.querySelector('.not-available-msg')) return 'out_of_stock';
        // quickview
        // <div class="oos-ewa"> Join the Waitlist</div>
        // <div class="oos-ewa"> Out Of Stock</div>
        const oos = document.querySelector('.oos-ewa');
        if (oos) {
          if (/out of stock/i.test(oos.textContent)) return 'out_of_stock';
          if (/waitlist/i.test(oos.textContent)) return 'email_when_in_stock';
        }
        return 'in_stock';
      } catch (e) {
        return undefined;
      }
    }();
    item.in_stock = in_stock;
  };
  const _itemsFromDataLayer = (isPurchase = false) => {
    // utag_data

    // cart

    // "page_context_type": "cart",
    // "page_context_title": "cart",
    // "product_name": ["Q Timex Reissue 38mm Stainless Steel Bracelet Watch", "Q Timex Reissue 38mm Stainless Steel Bracelet Watch"],
    // "product_brand": ["Timex", "Timex"],
    // "product_unit_price": ["179", "189"],
    // "product_unit_discount_amount": ["0.00", "0.00"],
    // "product_unit_price_paid": ["179.00", "189.00"],
    // "product_unit_discount_product_portion": ["0.00", "0.00"],
    // "product_unit_discount_order_portion": ["0.00", "0.00"],
    // "product_sku": ["TW2T80700", "TW2U62000"],
    // "product_id": ["TW2T80700ZV", "TW2U62000ZV"],
    // "product_category": ["q-timex-reissue", "q-timex-reissue"],
    // "product_quantity": ["1", "1"],
    // "product_coupon_discount": ["0", "0"],
    // "product_coupon_promo": [ "",  "" ],
    // "wheel_product_sku": ["TW2T80700", "TW2U62000"],

    const product_name = _getArray('product_name');
    const product_brand = _getArray('product_brand');
    const product_unit_price = _getArray('product_unit_price');
    const product_unit_discount_amount = _getArray('product_unit_discount_amount');
    const product_unit_price_paid = _getArray('product_unit_price_paid');
    // const product_unit_discount_product_portion = _getArray('product_unit_discount_product_portion');
    // const product_unit_discount_order_portion = _getArray('product_unit_discount_order_portion');
    const product_sku = _getArray('product_sku');
    const product_id = _getArray('product_id');
    const product_category = _getArray('product_category');
    const product_quantity = _getArray('product_quantity');
    // const product_coupon_discount = _getArray('product_coupon_discount');
    const product_coupon_promo = _getArray('product_coupon_promo');
    // const wheel_product_sku = _getArray('wheel_product_sku');

    return product_name.map((name, i) => {
      const discount = (_discount => {
        if (isNaN(_discount)) return 0;
        if (_discount < 0) return _discount * -1;
        return _discount;
      })(parseFloat(product_unit_discount_amount[i]));
      const unit_price = (() => {
        const price_paid = parseFloat(product_unit_price_paid[i]);
        const price = parseFloat(product_unit_price[i]);
        if (!isPurchase) return price;
        if (!isNaN(price_paid)) return price_paid;
        return price;
      })();
      return {
        item_id: product_sku[i],
        item_name: name,
        currency,
        discount,
        index: i,
        item_brand: product_brand[i],
        item_category: product_category[i],
        item_variant: product_id[i],
        coupon: product_coupon_promo[i],
        price: unit_price,
        quantity: parseInt(product_quantity[i], 10) || 1
      };
    });
  };
  const _value = items => items.map(i => (i.price - i.discount) * i.quantity).reduce((a, b) => a + b, 0);
  if (page_type === 'category') {
    log('category');
    dfc.load.then(() => {
      const items = [];
      $('#search-result-items li.grid-tile').each((_, el) => {
        const data = $(el).find('param').data(); // fetch product data
        if (data) {
          items.push(_itemFromData(data));
        } else {
          log('no data', el);
        }
      });
      gtag('event', 'view_item_list', {
        item_list_id: window.utag_data.page_category,
        // window.data is a DY thing
        item_list_name: typeof window.data === 'string' ? window.data : window.utag_data.page_category,
        items
      });
      $(document).on('click', '#search-result-items li.grid-tile', e => {
        const $this = $(e.target);
        const data = $(e.currentTarget).find('param').data();
        items.length = 0;
        items.push(_itemFromData(data));
        items.forEach(_setStock);
        gtag('event', 'select_item', {
          item_list_id: window.utag_data.page_category,
          item_list_name: typeof window.data === 'string' ? window.data : window.utag_data.page_category,
          items
        });
        if ($this.is('#quickviewbutton') || $this.closest('button#quickviewbutton').length) {
          gtag('event', 'view_item', {
            currency,
            value: items[0].price,
            items
          });
        }
      });
      $(document).on('click', 'button', e => {
        const $btn = $(e.currentTarget);
        if ($btn.length && $btn.attr('title') === 'Add to Bag') {
          gtag('event', 'add_to_cart', {
            currency,
            value: items[0].price,
            items
          });
        }
      });
    });
  }
  if (page_type === 'product') {
    log('product');
    const items = _itemsFromDataLayer();
    items.forEach(_setStock);
    gtag('event', 'view_item', {
      currency,
      value: items[0] && items[0].product_unit_price,
      items
    });
    $(document).on('click', '#add-to-cart', () => {
      if (items[0]) {
        items[0].quantity = function () {
          try {
            return $('#Quantity')[0].value || 1;
          } catch (e) {
            return 1;
          }
        }();
      }
      gtag('event', 'add_to_cart', {
        currency,
        value: items[0].price,
        items
      });
    });
  }
  if (page_name === 'confirmation' && page_type === 'checkout') {
    const items = _itemsFromDataLayer(true);
    gtag('event', 'purchase', {
      currency,
      transaction_id: _get('order_id'),
      value: _get('order_subtotal'),
      affiliation: document.hostname,
      coupon: _getArray('coupon_codes').find(Boolean),
      shipping: _get('order_shipping'),
      tax: _get('order_tax'),
      items
    });
  }
  dfc.load.then(() => {
    if (window.utag_data.page_context_type === 'cart') {
      const items = _itemsFromDataLayer();
      items.forEach(i => {
        i.item_list_id = 'cart';
        i.item_list_name = 'Cart';
      });
      gtag('event', 'view_cart', {
        currency,
        value: _value(items),
        items
      });
    }

    // begin_checkout
    if ($('.step-1.active').length > 0) {
      const items = _itemsFromDataLayer();
      gtag('event', 'begin_checkout', {
        currency,
        value: _value(items),
        coupon: items.map(i => i.coupon).find(Boolean),
        items
      });
    }
    if ($('.step-2.active').length > 0) {
      // we've added shipping
      const items = _itemsFromDataLayer();
      gtag('event', 'add_shipping_info', {
        currency,
        value: _value(items),
        coupon: items.map(i => i.coupon).find(Boolean),
        shipping_tier: ($('.checkout-order-totals .order-shipping .row').val() || '').trim() || $('#shipping-method-list option[selected]').text().trim() || undefined,
        items
      });
    }
    if ($('.step-3.active').length > 0) {
      // we've added payment
      const items = _itemsFromDataLayer();
      gtag('event', 'add_payment_info', {
        currency,
        value: _value(items),
        coupon: items.map(i => i.coupon).find(Boolean),
        payment_type: undefined,
        items
      });
    }
  });
  $(document).on('click', _e => {
    const $e = $(_e.target);
    if ($e.text() === 'REMOVE') {
      const data = $e.closest('button.cta-link').data();
      const items = _itemFromData(data);
      gtag('event', 'remove_from_cart', {
        currency,
        value: items[0].price,
        items
      });
    }

    // ApplePay
    if ($e.hasClass('dw-apple-pay-button')) {
      const items = _itemsFromDataLayer();
      gtag('event', 'add_payment_info', {
        currency,
        value: _value(items),
        coupon: items.map(i => i.coupon).find(Boolean),
        payment_type: 'Apple Pay',
        items
      });
    }
  });
});